import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { FieldModel } from "@cv-invision/cv.invision-views.ux";

@Component({
  selector: 'cv-slider-field',
  templateUrl: './slider-field.component.html',
  styleUrls: ['./slider-field.component.scss'],
})
export class SliderFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	@Input() show: any;
	@Input() active = false;
	selectedValue: number;

  constructor() {}

  ngOnInit(): void {
	  this.selectedValue = this.value * 100;
	  if(this.field.disabled){
		  this.control.disable();
	  }
  }

	setInputValue($event: any): void {
		this.selectedValue = $event.value * 100;
	}
}
